module.exports = __webpack_public_path__ + "static/img/special_ticket.f77bb026.png";